import React, { useState } from "react";
import {
  Box,
  Button,
  Divider,
  Drawer,
  IconButton,
  Stack,
  Toolbar,
  Typography,
  SwipeableDrawer,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  Paper,
  TextField,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { toggleSignUp } from "../../features/modals/modalSlice";
import { AccountCircle, MailLock, Password } from "@mui/icons-material";
import { registerUser } from "../../features/Auth/authSlice";
const SignUp = () => {
  const [credentials, setCredentials] = useState({
    name: "",
    email: "",
    password: "",
    password_confirmation: "",
  });
  const handleCredentials = (e) => {
    setCredentials({
      ...credentials,
      [e.target.name]: e.target.value,
    });
  };

  const { sigupModal } = useSelector((state) => state.modal);
  const { errorMsg } = useSelector((state) => state.auth);

  const dispatch = useDispatch();

  const handleOpenLogin = () => {
    dispatch(toggleSignUp());
  };

  const handleRegisterSubmit = (e) => {
    e.preventDefault();
    dispatch(registerUser(credentials));
    console.log(credentials);
  };

  return (
    <>
      {/* <pre>{JSON.stringify(credentials)}</pre> */}
      <SwipeableDrawer anchor="top" open={sigupModal} onClose={handleOpenLogin}>
        <Container maxWidth="md">
          <DialogTitle>Sign Up</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Please fill in all appropraite filds
            </DialogContentText>
            <Box>
              <Paper p={2} elevation={2}>
                <Box
                  sx={{ p: 2 }}
                  component="form"
                  onSubmit={handleRegisterSubmit}
                >
                  <Box py={2}>
                    <Grid container spacing={2}>
                      <Grid item xs={12} sm={6}>
                        <Box sx={{ display: "flex", alignItems: "flex-end" }}>
                          <AccountCircle
                            sx={{ color: "action.active", mr: 1, my: 0.5 }}
                          />
                          <TextField
                            id="input-with-sx"
                            label="username"
                            variant="standard"
                            fullWidth
                            type="text"
                            name="name"
                            value={credentials.name}
                            onChange={handleCredentials}
                            helperText={errorMsg?.name}
                            required
                          />
                        </Box>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Box sx={{ display: "flex", alignItems: "flex-end" }}>
                          <MailLock
                            sx={{ color: "action.active", mr: 1, my: 0.5 }}
                          />
                          <TextField
                            id="input-with-sx"
                            label="Email"
                            variant="standard"
                            fullWidth
                            type="email"
                            name="email"
                            value={credentials.email}
                            onChange={handleCredentials}
                            helperText={errorMsg?.email}
                            required
                          />
                        </Box>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Box sx={{ display: "flex", alignItems: "flex-end" }}>
                          <Password
                            sx={{ color: "action.active", mr: 1, my: 0.5 }}
                          />
                          <TextField
                            id="input-with-sx"
                            label="Password "
                            variant="standard"
                            fullWidth
                            type="password"
                            name="password"
                            value={credentials.password}
                            onChange={handleCredentials}
                            helperText={errorMsg?.password}
                            required
                          />
                        </Box>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Box sx={{ display: "flex", alignItems: "flex-end" }}>
                          <Password
                            sx={{ color: "action.active", mr: 1, my: 0.5 }}
                          />
                          <TextField
                            id="input-with-sx"
                            label="Confirm password"
                            variant="standard"
                            fullWidth
                            type="password"
                            name="password_confirmation"
                            value={credentials.password_confirmation}
                            onChange={handleCredentials}
                            helperText={errorMsg?.password_confirmation}
                            required
                          />
                        </Box>
                      </Grid>
                    </Grid>
                  </Box>
                  <Box sx={{ display: "flex", justifyContent: "center" }}>
                    <Button variant="outlined" size="large" type="submit">
                      Sign Up
                    </Button>
                  </Box>
                </Box>
              </Paper>
            </Box>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleOpenLogin} color="error" variant="outlined">
              Close
            </Button>
          </DialogActions>
        </Container>
      </SwipeableDrawer>
    </>
  );
};

export default SignUp;
